import React, { useMemo } from 'react';
import { Flex, ResponsiveValue } from '@chakra-ui/react';

import { useFilters, styles } from '../../../../../lib';
import { SearchFilter } from '../';
import { UnifiedFilterPill } from './UnifiedFilterPill';
import { __ } from '../../../../../lib/i18n';

export const RenderHorizontalFilters = () => {
	const { filters, defaultFilters, handleApplyFilters } = useFilters();

	const filterConfigs = useMemo(
		() => [
			{
				filterKey: 'selectedEventTypes',
				label: __('Categories'),
				options: defaultFilters.eventTypes,
				selectedOptions: filters.selectedEventTypes,
				isMulti: true,
				showColors: true,
			},
			{
				filterKey: 'selectedEventLocations',
				label: __('Venues'),
				options: defaultFilters.eventLocations,
				selectedOptions: filters.selectedEventLocations,
				isMulti: true,
			},
			{
				filterKey: 'selectedEventTags',
				label: __('Tags'),
				options: defaultFilters.eventTags,
				selectedOptions: filters.selectedEventTags,
				isMulti: true,
			},
			{
				filterKey: 'selectedCountries',
				label: __('Country'),
				options: defaultFilters.countries,
				selectedOptions: filters.selectedCountries,
				isMulti: false,
			},
			{
				filterKey: 'selectedStates',
				label: __('State'),
				options: defaultFilters.states,
				selectedOptions: filters.selectedStates,
				isMulti: false,
				disabled: !filters.selectedCountries.length,
			},
			{
				filterKey: 'selectedCities',
				label: __('City'),
				options: defaultFilters.cities,
				selectedOptions: filters.selectedCities,
				isMulti: false,
				disabled: !filters.selectedStates.length || !filters.selectedCountries.length,
			},
		],
		[filters, defaultFilters]
	);

	const { filterPillsWrap } = styles.filters;
	return (
		<Flex direction='column' gap={4} w='full' paddingBlock={4}>
			<SearchFilter onApplyFilters={handleApplyFilters} />
			<Flex gap={2} flexWrap={filterPillsWrap as ResponsiveValue<'wrap' | 'nowrap'>}>
				{filterConfigs.map((config) => (
					<UnifiedFilterPill key={config.filterKey} {...config} onApplyFilters={handleApplyFilters} />
				))}
			</Flex>
		</Flex>
	);
};
